import { RelationshipEntity } from '../entities/relationship-entity';

export default class State {
  loaded = false;

  items: Array<RelationshipEntity> = [];
}
